import React from 'react';
import { useLocation } from 'react-router-dom';
import { useAuth } from '../../contexts/AuthContext';
import Icon from '../AppIcon';

const Header = ({ onMenuClick }) => {
  const { user, logout } = useAuth();
  const location = useLocation();

  const getPageTitle = (pathname) => {
    if (pathname.includes('/vendor-profile-details')) return 'Vendor Profile';
    
    switch (pathname) {
      case '/dashboard-overview': return 'Dashboard';
      case '/vendor-master-list': return 'Vendor Master';
      case '/vendor-approval-workflow': return 'Approvals';
      case '/supplier-requests': return 'Requests';
      case '/vendor-excel-import': return 'Excel Import';
      case '/supplier-request-form': return 'New Request';
      case '/user-management': return 'User Management';
      case '/invite-management': return 'Invite Management';
      default: return '';
    }
  };

  const pageTitle = getPageTitle(location.pathname);

  return (
    <header className="sticky top-0 z-30 w-full bg-[rgba(247,246,241,0.72)] backdrop-blur-[18px] border-b border-cos-line-subtle shadow-sm transition-all duration-200 h-16">
      <div className="flex items-center justify-between h-full px-4 sm:px-6 lg:px-8">
        
        {/* Left Section: Mobile Menu & Title */}
        <div className="flex items-center gap-4 flex-1">
          <button
            onClick={onMenuClick}
            className="lg:hidden p-2 -ml-2 text-cos-ink-muted hover:text-cos-teal-deep hover:bg-cos-surface-hover rounded-md transition-colors"
          >
            <Icon name="Menu" size={24} />
          </button>
          
          <div className="flex flex-col justify-center">
            {pageTitle && (
              <h1 className="text-xl font-bold text-cos-ink tracking-tight leading-none">
                {pageTitle}
              </h1>
            )}
          </div>
        </div>

        {/* Right Section: Actions & Profile */}
        <div className="flex items-center gap-2 sm:gap-4">
          {/* User Profile */}
          <div className="relative group">
            <button className="flex items-center gap-3 p-1 rounded-full hover:bg-cos-surface-hover transition-colors">
              <div className="w-8 h-8 rounded-full bg-cos-teal-faint flex items-center justify-center border border-cos-teal/20 text-cos-teal-deep font-semibold text-sm">
                {user?.username?.[0]?.toUpperCase() || 'U'}
              </div>
              <div className="hidden md:block text-left mr-1">
                <p className="text-sm font-semibold text-cos-ink leading-none">{user?.username || 'User'}</p>
                <p className="text-xs text-cos-ink-muted mt-0.5 capitalize">{user?.role || 'Guest'}</p>
              </div>
              <Icon name="ChevronDown" size={16} className="text-cos-ink-muted hidden md:block" />
            </button>
            
            {/* Dropdown */}
            <div className="absolute right-0 mt-2 w-48 bg-white rounded-lg shadow-lg border border-cos-line-subtle py-1 opacity-0 invisible group-hover:opacity-100 group-hover:visible transition-all duration-200 transform origin-top-right z-50">
              <div className="px-4 py-2 border-b border-cos-line-subtle md:hidden">
                <p className="text-sm font-medium text-cos-ink">{user?.username}</p>
                <p className="text-xs text-cos-ink-muted">{user?.email}</p>
              </div>
              <div className="flex items-center px-4 py-2 text-sm text-cos-ink-muted cursor-not-allowed opacity-60">
                <Icon name="User" size={16} className="mr-2" /> Profile
              </div>
              <div className="flex items-center px-4 py-2 text-sm text-cos-ink-muted cursor-not-allowed opacity-60">
                <Icon name="Settings" size={16} className="mr-2" /> Settings
              </div>
              <div className="border-t border-cos-line-subtle my-1"></div>
              <button 
                onClick={logout}
                className="w-full flex items-center px-4 py-2 text-sm text-cos-status-coral hover:bg-cos-status-coral-bg transition-colors"
              >
                <Icon name="LogOut" size={16} className="mr-2" /> Sign Out
              </button>
            </div>
          </div>
        </div>
      </div>
    </header>
  );
};

export default Header;